import { createFileRoute } from "@tanstack/react-router";

import ReviewDetail from "@/pages/review/ReviewDetail";

function ReviewDetailPage() {
  const { caseId } = Route.useParams();
  return <ReviewDetail caseId={caseId} />;
}

export const Route = createFileRoute("/review/$caseId")({
  component: ReviewDetailPage,
});
